import noUiSlider from 'nouislider';

const blockOverflow = () => {
	const overflowDiv = document.getElementById('js-block-overflow');
	const overflowSlider = document.getElementById('js-block-overflow-slider');
	const total = overflowDiv.scrollWidth - overflowDiv.offsetWidth;

	if (total === 0) {
		overflowSlider.style.display = 'none';
		return;
	}

	overflowSlider.style.display = 'block';

	if (overflowSlider.noUiSlider) {
		overflowSlider.noUiSlider.updateOptions({
			start: [0],
			connect: [true, false],
			range: {
				min: [0],
				max: total,
			},
		});
	} else {
		noUiSlider.create(overflowSlider, {
			start: [0],
			connect: [true, false],
			range: {
				min: [0],
				max: total,
			},
		});

		overflowSlider.noUiSlider.on('update', (values, handle) => {
			overflowDiv.scrollLeft = parseInt(values[handle], 10);
		});
	}
};

export default blockOverflow;
